import { useState } from 'react';
import {
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ProjectStateTypes, UserTypes } from '../../../../../config/enums';
import { ProjectProps } from '../../../../../config/interfaces';
import { useLoginState } from '../../../../../hooks/loginInfo';
import { useChangeProjectStateMutation } from '../../../../../../graphql/generated/graphql';
import { setAlertDescription } from '../../../../../hooks/actions';

const ButtonsProject = (props: ProjectProps) => {
  const navigate = useNavigate();
  const loginState = useLoginState();
  const [changeProjectState] = useChangeProjectStateMutation();
  const { project, refetch } = props;
  const isActions = loginState.user_type.get() === UserTypes.PRODUCER;
  const [disabled, setDisabled] = useState(false);
  const [loaderAccept, setLoaderAccept] = useState(false);
  const [loaderDecline, setLoaderDecline] = useState(false);
  const isAccept = (project.status === 'REVIEW' && loginState.company_id.get());
  const isEdit = (project.status !== 'DONE' && loginState.user_type.get() === UserTypes.PRODUCER);
  const isTextWrapped = project.status === 'DONE';

  const editToProject = (event: any) => {
    event.stopPropagation();
    navigate(`/project/edit/${project.id}`);
  };

  const onChangeState = async (state: string, event: any) => {
    event.stopPropagation();
    if (state === "ACCEPTED") {
      setLoaderAccept(true);
    } else if (state === "REJECTED") {
      setLoaderDecline(true)
    }
    try {
      await changeProjectState({
        variables: {
          project_id: project.id as string,
          state,
        },
      }).then(res => {
        setAlertDescription({
          open: true,
          message: `The project ${project.project_name} has been ${state}`,
          severity: 'success',
        });
        if (refetch) {
          refetch();
        }
      });
    } catch (e) {
      setDisabled(false);
      console.error(e);
    }
  };

  const acceptButton = isAccept ? (
    <Button
      variant="contained"
      onClick={(e) => {
        onChangeState(ProjectStateTypes.ACCEPTED, e);
      }}
      disabled={disabled}
      type="submit"
      size="small"
      color="success"
      sx={{
        fontWeight: 500,
      }}
    >
      {loaderAccept ? (
        <CircularProgress size={25} color="primary" />
      ) : (
        'Accept'
      )}

    </Button>
  ) : null;

  const declineButton = isAccept ? (
    <Button
      variant="contained"
      onClick={(e) => {
        onChangeState(ProjectStateTypes.REJECTED, e);
      }}
      disabled={disabled}
      type="submit"
      size="small"
      color="error"
      sx={{
        fontWeight: 500,
      }}
    >
      {loaderDecline ? (
        <CircularProgress size={25} color="primary" />
      ) : (
        'Decline'
      )}
    </Button>
  ) : null;

  const textWrapped = isTextWrapped ? (
    <Typography
      sx={{
        ml: 1,
        fontWeight: '500',
      }}
      component="p"
      variant="body2"
    >
      Wrapped
    </Typography>
  ) : null;

  return (
    <>
      {isActions ? (
        <>
          {acceptButton}
          {declineButton}
        </>
      ) : null}
      {textWrapped}
    </>
  )
};

export default ButtonsProject;
